/* ================================================================
   Mor & Meadow — Lenis smooth-scroll bootstrap.

   Mirrors the Next.js `SmoothScrollProvider` so the Shopify storefront
   feels identical to morandmeadow.com:
     - 1.4s exponential ease-out (matches the React reference exactly)
     - Disabled when `prefers-reduced-motion: reduce` is set
     - Anchor links (`a[href^="#"]`) are intercepted to scroll smoothly
       with a 96px offset for the fixed header
     - Exposes `window.__lenis` so sections (process-cards, framework,
       …) can opt into smooth `lenis.scrollTo(target, { duration })`
       calls instead of native `window.scrollTo`

   Lenis itself is loaded earlier in <head> as a vendored asset via:
     {{ 'lenis.min.js' | asset_url }}
   Both scripts use `defer` so they execute in document order. The
   short setTimeout retry below is a defensive fallback for any
   environment where the global `window.Lenis` hasn't appeared yet.
   ================================================================ */
(function () {
  if (window.__mamLenisInit) return;
  window.__mamLenisInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function init(retries) {
    if (window.__lenis) return;
    /* Skip on reduced-motion preference. Lenis is intentionally tied
       to user motion settings — falling back to native scrolling. */
    if (window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    if (typeof window.Lenis !== 'function') {
      /* CDN delayed — retry up to ~2s. After that, give up gracefully
         and the site falls back to native smooth scrolling. */
      if (retries === undefined) retries = 0;
      if (retries > 20) return;
      setTimeout(function () { init(retries + 1); }, 100);
      return;
    }

    var lenis = new window.Lenis({
      duration: 1.4,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      touchMultiplier: 1
    });
    window.__lenis = lenis;

    function tick(time) {
      lenis.raf(time);
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    /* Anchor link interception — same contract as the React version.
       Lenis handles the scroll, the 96px offset clears the fixed
       header. */
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var link = target.closest('a[href^="#"]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href === '#') return;
      /* Only handle plain in-page hash links — not tab triggers etc. */
      var el = document.querySelector(href);
      if (!el) return;
      e.preventDefault();
      lenis.scrollTo(el, { offset: -96 });
    });
  }

  ready(function () { init(0); });
})();
